import React, { useEffect, useRef, useState } from 'react';
import { FaDownload, FaSpinner, FaInfoCircle } from 'react-icons/fa';
import { drawQRCode, downloadCanvas } from '../utils/qr-helper';
import { motion, AnimatePresence } from 'framer-motion';

const QRPreview = ({ content, config, isMagicLoading }) => {
  const canvasRef = useRef(null);

  useEffect(() => {
    if (content && canvasRef.current) {
      const timer = setTimeout(() => {
        drawQRCode(canvasRef.current, content, config);
      }, 100);
      return () => clearTimeout(timer);
    }
  }, [content, config]);

  const handleDownload = () => {
    if (canvasRef.current) {
      // 給予一點點時間確保 Canvas 繪製完成（特別是 Logo）
      downloadCanvas(canvasRef.current, `qr-planet-${Date.now()}.png`);
    }
  };

  return (
    <div className="flex flex-col items-center gap-6 w-full">
      <div className="relative group w-full max-w-[280px] aspect-square">
        <div className="absolute -inset-1 bg-gradient-to-br from-primary via-accent to-secondary rounded-2xl blur opacity-20 group-hover:opacity-40 transition-opacity duration-500"></div>
        
        <div className="relative bg-white p-4 rounded-xl shadow-2xl h-full w-full flex items-center justify-center overflow-hidden">
          <canvas 
            ref={canvasRef} 
            className="w-full h-full object-contain z-10"
          />
          
          <AnimatePresence>
            {isMagicLoading && (
              <motion.div 
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                className="absolute inset-0 z-20 bg-slate-900/80 backdrop-blur-sm flex flex-col items-center justify-center"
              >
                <div className="text-white font-bold text-lg animate-pulse flex flex-col items-center gap-2">
                  <FaSpinner className="animate-spin text-3xl" />
                  <span>魔法調色中</span>
                </div>
              </motion.div>
            )}
          </AnimatePresence>
        </div>
      </div>

      <div className="w-full max-w-[280px] space-y-4">
        <button 
          onClick={handleDownload}
          disabled={isMagicLoading || !content}
          className="btn-primary w-full flex items-center justify-center gap-2 group disabled:opacity-50"
        >
          <FaDownload className="group-hover:animate-bounce" />
          <span>下載圖片</span>
        </button>

        {/* 掃瞄提示 - SEO 優化與 UX */}
        <div className="bg-slate-800/40 border border-white/5 rounded-lg p-3">
          <div className="flex items-start gap-2 text-xs text-slate-400">
            <FaInfoCircle className="mt-0.5 text-primary flex-shrink-0" />
            <ul className="list-disc pl-3 space-y-1">
              <li>若掃描失敗，請嘗試將「背景」設為白色。</li>
              <li>「定位點」採用方形或圓角效果最佳。</li>
              <li>Logo 若過大可能會影響識別率。</li>
            </ul>
          </div>
        </div>
      </div>

      {!content && (
        <p className="text-amber-400 text-sm bg-amber-400/10 px-3 py-1 rounded-full border border-amber-400/20">
          請輸入內容以預覽
        </p>
      )}
    </div>
  );
};

export default QRPreview;